import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 5.625c2.188 0 3.965 1.012 5.25 2.215 1.285 1.176 2.133 2.598 2.543 3.582a.98.98 0 0 1 0 .683c-.41.957-1.258 2.38-2.543 3.582-1.285 1.204-3.062 2.188-5.25 2.188-2.215 0-3.992-.984-5.277-2.187-1.285-1.204-2.133-2.626-2.543-3.583a.98.98 0 0 1 0-.683c.41-.985 1.258-2.406 2.543-3.582C8.008 6.637 9.785 5.625 12 5.625M8.063 11.75c0 1.422.738 2.707 1.968 3.418 1.203.71 2.707.71 3.938 0a3.97 3.97 0 0 0 1.969-3.418c0-1.395-.766-2.68-1.97-3.39a3.9 3.9 0 0 0-3.937 0 3.9 3.9 0 0 0-1.969 3.39M12 10c0-.191-.055-.355-.11-.547-.054-.137.055-.328.22-.328a2.64 2.64 0 0 1 2.406 1.969c.382 1.394-.438 2.816-1.86 3.199a2.603 2.603 0 0 1-3.199-1.86 2 2 0 0 1-.082-.546c-.027-.164.164-.274.3-.219.192.055.356.082.575.082.957 0 1.75-.766 1.75-1.75"
    }, null, -1)
  ]))]))
}
export default { render: render }